import {ComponentProps} from "react";

import {ContactBar} from "../../atoms/contact_bar/ContactBar";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {usePropertyReservationState} from "../hooks/use_property_reservation_state";
import {useStartReservationFlow} from "../hooks/use_start_reservation_flow";
import {PropertyReservationCtaView} from "./PropertyReservationCtaView";

type IProps = Omit<ComponentProps<typeof ContactBar>, "secondaryCta"> & {
    property: IPropertyDetail;
};

const RESERVATION_INFO_TEXT = (
    <>
        Zapytaj o ofertę lub skorzystaj z opcji <strong>bezpłatnej rezerwacji</strong>.
    </>
);

// next to the unavailable button the line no longer invites the user to reserve, but it stays - the bar's height is measured once, with the line
const RESERVED_INFO_TEXT = "Ten lokal jest już zarezerwowany. Zapytaj o ofertę.";

// The contact bar of the property page - any reservation CTA switches the bar layout, so it is passed only when the button can show up
export const PropertyContactBarWithReservation = (props: IProps) => {
    const {property, ...contactBarProps} = props;

    const {ctaState, request} = usePropertyReservationState(property, "contact_bar");
    const startReservation = useStartReservationFlow(request, {offerName: property.offer.name});

    if (ctaState === "hidden") {
        return <ContactBar {...contactBarProps} />;
    }

    return (
        <ContactBar
            {...contactBarProps}
            secondaryCta={{
                // as tall as the other buttons of the bar
                button: (
                    <PropertyReservationCtaView
                        ctaState={ctaState}
                        placement="contact_bar"
                        size={contactBarProps.buttonsSize ?? "small"}
                        onStart={startReservation}
                    />
                ),
                info: ctaState === "reserved" ? RESERVED_INFO_TEXT : RESERVATION_INFO_TEXT
            }}
        />
    );
};
import {ComponentProps} from "react";

import {ContactBar} from "../../atoms/contact_bar/ContactBar";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {usePropertyReservationState} from "../hooks/use_property_reservation_state";
import {useStartReservationFlow} from "../hooks/use_start_reservation_flow";
import {PropertyReservationCtaView} from "./PropertyReservationCtaView";

type IProps = Omit<ComponentProps<typeof ContactBar>, "secondaryCta"> & {
    property: IPropertyDetail;
};

const RESERVATION_INFO_TEXT = (
    <>
        Zapytaj o ofertę lub skorzystaj z opcji <strong>bezpłatnej rezerwacji</strong>.
    </>
);

// next to the unavailable button the line no longer invites the user to reserve, but it stays - the bar's height is measured once, with the line
const RESERVED_INFO_TEXT = "Ten lokal jest już zarezerwowany. Zapytaj o ofertę.";

// The contact bar of the property page - any reservation CTA switches the bar layout, so it is passed only when the button can show up
export const PropertyContactBarWithReservation = (props: IProps) => {
    const {property, ...contactBarProps} = props;

    const {ctaState, request} = usePropertyReservationState(property, "contact_bar");
    const startReservation = useStartReservationFlow(request, {offerName: property.offer.name});

    if (ctaState === "hidden") {
        return <ContactBar {...contactBarProps} />;
    }

    return (
        <ContactBar
            {...contactBarProps}
            secondaryCta={{
                // as tall as the other buttons of the bar
                button: (
                    <PropertyReservationCtaView
                        ctaState={ctaState}
                        placement="contact_bar"
                        size={contactBarProps.buttonsSize ?? "small"}
                        onStart={startReservation}
                    />
                ),
                info: ctaState === "reserved" ? RESERVED_INFO_TEXT : RESERVATION_INFO_TEXT
            }}
        />
    );
};
